import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {Form} from 'react-bootstrap';

import CustomMultiSelect from '../../../components/commons/helpers/customMultiSelect';

import {aflt_departmentsListAction} from '../../../actions/settings/affiliates/aflt_departmentActions'; 
import {payLevelsListAction} from '../../../actions/settings/affiliates/payLevelsActions';

import * as types from '../../../actions';

class FilterSchedule extends Component {

    constructor(props){
        super(props)
        this.state = {          
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            dptClicked: 0,
            ratingFrom:'',
            ratingTo:'',
            payLevels:[],
            selectedPayLevel:[],
            departments:[],
            selectedDpt:[],
            has_vehicle:'',
            pointFrom:'',
            pointTo:'',
            isFormChanged:0,            
        }
    }    

    sendFilterData = () => {   
        let {selectedDpt,ratingFrom,ratingTo,selectedPayLevel,pointFrom,pointTo,has_vehicle } = this.state;
        let filterData = {ratingFrom:ratingFrom, ratingTo:ratingTo, payLevel:selectedPayLevel, pointFrom:pointFrom, pointTo:pointTo,has_vehicle:has_vehicle,departments:selectedDpt.length>0?selectedDpt:this.props.departments}; 
        this.props.applyFilters(filterData); 
    }

    resetFilters = () => { 
        this.setState({     
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            dptClicked: 0,
            ratingFrom:'',
            ratingTo:'',
            payLevels:[],
            selectedPayLevel:[],
            departments:[],
            selectedDpt:[],
            has_vehicle:'',
            pointFrom:'',
            pointTo:'',
            isFormChanged:0
        }); 
        // TO RESET MULTISEL VALUES 
        this.props.aflt_departmentsListAction({associated:'1'});
        this.props.payLevelsListAction();
    }    

    onHandleChange = (e) => {     
        const {name,value}  = e.target;
        //let trimmedValue    = value.trim();
        let isFormChanged = 0;
   
        switch(name){    
            case 'ratingFrom':
                let ratingFrom = Number(value) <=5 && Number(value)>0 ?Number(value):'';
                this.setState({ratingFrom:ratingFrom,ratingTo:''});
                isFormChanged = 1;
                break; 
            case 'ratingTo':
                let ratingTo = Number(value) > this.state.ratingFrom && Number(value) <=5 && Number(value)>0?Number(value) :'';
                this.setState({ratingTo:ratingTo});
                isFormChanged = 1;
                break;         
            case 'pointFrom':
                let pointFrom = Number(value);
                this.setState({pointFrom:pointFrom,pointTo:''});
                isFormChanged = 1;
                break;    
            case 'pointTo':
                let pointTo = Number(value);
                this.setState({pointTo:pointTo});
                isFormChanged = 1;
                break;       
            default :
            break;
        }
        this.setState({
            //[name]:Number(value),          
            isFormChanged:isFormChanged         
        });
    }  

    onSelectOption = (e) => {
        let stateVar = this.state; 
        stateVar[e.target.name] = e.target.value; 
        this.setState({...stateVar}); 
    }

    handleChangeDpt = (selectedDepts) =>{
        let isFormChanged = 0;
        let deptSelected = []; 
        selectedDepts.forEach((item) => {
            deptSelected.push(item.value);
        });   
        if(deptSelected.length>0){
            isFormChanged = 1; 
        }else{
            isFormChanged = 0;
        }    
        this.setState({selectedDpt:deptSelected,isFormChanged:isFormChanged}); 
    }

    handleChangePayLevel = (selected) =>{
        let isFormChanged = 0;
        let payLevelSelected = []; 
        selected.forEach((item) => {
            payLevelSelected.push(item.value);
        });   
        if(payLevelSelected.length>0){
            isFormChanged = 1; 
        }else{
            isFormChanged = 0;
        }    
        this.setState({selectedPayLevel:payLevelSelected,isFormChanged:isFormChanged}); 
    }

    componentDidUpdate (prevProps) {
        if(this.props.filterClicked!==prevProps.filterClicked) {       
            if(this.props.sendAssociated && this.props.sendAssociated > 0)  {
                let dataObj = {associated:1}; 
                this.props.aflt_departmentsListAction(dataObj);
            }   
            else {
                this.props.aflt_departmentsListAction({associated:'1'});
            } 
            this.props.payLevelsListAction();
        } 

        if(this.props.applyFilterClicked > 0 && this.props.applyFilterClicked!==prevProps.applyFilterClicked && this.state.applyFilterClicked < this.props.applyFilterClicked) {
            this.setState({applyFilterClicked:this.props.applyFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.sendFilterData(); 
        }

        if(this.props.resetFilterClicked > 0 && this.props.resetFilterClicked!==prevProps.resetFilterClicked && this.state.resetFilterClicked < this.props.resetFilterClicked) {
            this.setState({resetFilterClicked:this.props.resetFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.resetFilters(); 
        }

        const {departmentsList,status,activity,payLevelList,subactivity} = this.props; 
        const {selectedDpt, selectedPayLevel} = this.state;         
        if (activity && activity !== prevProps.activity) {
            let arrTmp = [];
            arrTmp = (activity) ? activity.split('~~') : [];
            let actString = arrTmp[0];         

            if(actString===types.DEPARTMENT_LIST_AFFILIATE_SUCCESS) { 
                let departments = [];  
                if(status===200) {        
                    if(departmentsList && Array.isArray(departmentsList)){
                        departmentsList.forEach(item => { 
                            let dptExist = false;
                            if(selectedDpt.length>0){
                                dptExist =  selectedDpt.some(dpt => dpt === item.id);
                            }else{
                                dptExist =  this.props.departments.some(dpt => dpt === item.id);
                            }    
                            if(dptExist){
                                departments.push({value:item.id, label:item.name,inputVal: item.id});
                            }else{
                                departments.push({value:item.id, label:item.name});
                            }
                        });            
                    }
                }
                this.setState({departments:departments}); 
            }
        }else if (subactivity && subactivity !== prevProps.subactivity) {
            let arrTmp = [];
            arrTmp = (subactivity) ? subactivity.split('~~') : [];
            let actString = arrTmp[0];    
            if(actString===types.PAY_LEVELS_LIST_SUCCESS){                
                let payLevels = [];  
                    if(payLevelList && Array.isArray(payLevelList)){
                        payLevelList.forEach(item => { 
                            let isExist = false;
                            if(selectedPayLevel.length>0){
                                isExist =  selectedPayLevel.some(pay => pay === item.id);
                            }
                            if(isExist){
                                payLevels.push({value:item.id, label:item.level_name,inputVal: item.id});
                            }else{
                                payLevels.push({value:item.id, label:item.level_name});
                            }
                        });            
                    }
                
                this.setState({payLevels:payLevels}); 
            }
        }else{
            //if(this.props.departments.length>0){
                let departments = []; 
                if(departmentsList && Array.isArray(departmentsList)){
                    departmentsList.forEach(item => { 
                        let dptExist = false;                     
                        dptExist =  this.props.departments.some(dpt => dpt === item.id);                           
                        if(dptExist){
                            departments.push({value:item.id, label:item.name,inputVal: item.id});
                        }else{
                            departments.push({value:item.id, label:item.name});
                        }
                    });            
                }                
                if(this.props.dptClicked > 0 && this.props.dptClicked!==prevProps.dptClicked && this.state.dptClicked < this.props.dptClicked) {
                    this.setState({departments:departments,dptClicked:this.props.dptClicked}); 
                }
            //}
        }
    }

    
    render(){
        let {departments,ratingFrom,ratingTo,payLevels,pointFrom,pointTo,has_vehicle} = this.state; 
        
        return(
            <React.Fragment>
                <Form autoComplete="off" className="filter-block">    
                    <div className="filter-category">                   
                        <div className="row"> 
                            <div className="col-6"> 
                                <h4>Rating From</h4>
                            </div>
                            <div className="col-6"> <h4>To</h4></div>
                        </div>
                        <div className="form-group">
                            <div className="row">
                                <div className="col-6">
                                    <div className="text-input">
                                        <input type="text" placeholder="Eg 1" name="ratingFrom" onChange={this.onHandleChange} value={ratingFrom || ''}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="text-input">
                                        <input type="text" placeholder="Eg 5" name="ratingTo" onChange={this.onHandleChange} value={ratingTo || ''} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>    
                    <div className="filter-category">                        
                        <div className="form-group">
                            <h4>Pay Level</h4>
                            <div className="form-group multisel_textbox">
                                <div className="form-group select-input skills" >
                                    <CustomMultiSelect data={payLevels}  onChange={selected =>this.handleChangePayLevel(selected)} isTextBox={false} needSelectAll={true} />
                                </div>
                            </div>
                        </div>    
                    </div>             
                    <div className="filter-category">                        
                        <div className="form-group">
                            <h4>Departments</h4>
                            <div className="form-group multisel_textbox">
                                <div className="form-group select-input skills" >
                                    <CustomMultiSelect data={departments}  onChange={selected =>this.handleChangeDpt(selected)} isTextBox={false} needSelectAll={true} />
                                </div>
                            </div>
                        </div>    
                    </div>

                    <div className="filter-category">                        
                        <div className="form-group">
                            <h4>Has Vehicle</h4>
                            <div className="select-input">  
                                <select onChange={(e) => this.onSelectOption(e)} name="has_vehicle" value={has_vehicle}  >
                                    <option value="" data-loc="">All</option>
                                    <option value='true'>Yes</option> 
                                    <option value='false'>No</option> 
                                </select>
                            </div>
                        </div>    
                    </div>

                    <div className="filter-category"> 
                        <div className="row"> 
                            <div className="col-6"> 
                                <h4>Crew App Points From</h4>
                            </div>
                            <div className="col-6"> <h4>To</h4></div>
                        </div>
                        <div className="form-group">
                            <div className="row">
                                <div className="col-6">
                                    <div className="text-input">
                                        <input type="text" placeholder="Eg 1" name="pointFrom" onChange={this.onHandleChange} value={pointFrom || ''} />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="text-input">
                                        <input type="text" placeholder="Eg 5" name="pointTo" onChange={this.onHandleChange} value={pointTo || ''} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                   
            
                </Form>    
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => { 
    return {
        departmentsList : state.afltDepartments.departmentsList,
        payLevelList : state.payLevel.items,
        status: state.afltDepartments.status,
        activity: state.afltDepartments.activity,
        errorData: state.afltDepartments.errorData,
        subactivity:state.payLevel.subactivity,        
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        aflt_departmentsListAction:aflt_departmentsListAction,         
        payLevelsListAction:payLevelsListAction      
    },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(FilterSchedule);